// extracted by mini-css-extract-plugin
export default {"tabNavigation":"TabNavigation_tabNavigation__MN+n5","active":"TabNavigation_active__YXRhU","tab-content":"TabNavigation_tab-content__tYIhq"};